module.exports = __webpack_public_path__ + "img/fig01.01f04eb8.jpg";